import { Dispatch, SetStateAction, useState } from 'react';

import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Input from '@/components/basicComponents/input';
import styled from 'styled-components';
import { IListData } from '../types';

interface CreateTagProps {
  isOpen: boolean;
  preFillValue: string;
  setTags: Dispatch<SetStateAction<IListData>>;
  onClose: () => void;
}

const CreateTag = ({ isOpen, preFillValue, setTags, onClose }: CreateTagProps) => {
  const [value, setValue] = useState(preFillValue || '');

  const handleCloseDialog = () => {
    setTags((prev) => ({ ...prev, preFillValue: '' }));
    onClose();
  };

  const saveValue = () => {
    setTags((prevTags) => {
      if (!prevTags.list.includes(value)) {
        return { ...prevTags, list: [...prevTags.list, value] };
      }
      return prevTags;
    });

    setTags((prevTags) => {
      if (!prevTags.list.length) {
        return {
          ...prevTags,
          chosen: [...new Set([...prevTags.chosen, value])]
        };
      }

      let duplicateTag = '';

      const updatedTags = prevTags.chosen.map((tag) => {
        if (tag === '') {
          return value;
        }
        if (tag === value) {
          duplicateTag = value;
          return value;
        }
        return tag;
      });

      return { ...prevTags, chosen: updatedTags, duplicate: duplicateTag || null };
    });

    setTimeout(() => {
      setTags((prevTags) => {
        return {
          ...prevTags,
          duplicate: null,
          chosen: [...new Set(prevTags.chosen)]
        };
      });
    }, 1000);
    handleCloseDialog();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={handleCloseDialog}
      title="Create New Tag"
      confirmButton={{
        name: 'Save',
        onClick: saveValue,
        disabled: !value.length
      }}
      showRequiredFields
    >
      <ModalDescription>Use tags to call out common attributes on different investments.</ModalDescription>
      <ManagerInputWrap>
        <Input label="Tag" placeholder="Provide a Tag" value={value} onChange={(e) => setValue(e.target.value)} isRequiredField autoFocus />
      </ManagerInputWrap>
    </ModalWrappedContent>
  );
};

export default CreateTag;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${({ theme }) => theme.font.base};
`;

const ManagerInputWrap = styled.div`
  padding-top: 35px;
`;
